module.exports = __webpack_public_path__ + "img/3.ab5fa0af.png";